/**
 * Utility functions for normalizing and working with agent tool names
 */

/**
 * Default version number used when normalizing tool versions.
 * All versioned tools are normalized to this version for consistent handling.
 */
const DEFAULT_TOOL_VERSION = '2';

/**
 * Normalizes tool names by handling version suffixes
 * @param toolName - Raw tool name (e.g., "query_supabase_v3", "fetch_audience_v2")
 * @returns Object with normalized versions of the tool name
 */
export function normalizeToolName(toolName: string): {
  /** Original tool name */
  original: string;
  /** Normalized with spaces replaced by underscores and lowercased */
  normalized: string;
  /** Normalized with version suffix replaced to v2 (e.g., query_supabase_v3 -> query_supabase_v2) */
  versionNormalized: string;
  /** Normalized with version suffix stripped (e.g., fetch_audience_v2 -> fetch_audience) */
  versionStripped: string;
} {
  const normalized = toolName.toLowerCase().trim().replace(/\s+/g, '_');
  const versionNormalized = normalized.replace(/(_v)\d+$/, `$1${DEFAULT_TOOL_VERSION}`);
  const versionStripped = normalized.replace(/_v\d+$/, '');

  return {
    original: toolName,
    normalized,
    versionNormalized,
    versionStripped,
  };
}
